import { Record } from 'immutable';

const struct = {
  id:          undefined,
  name:        undefined,
  title:       undefined,
  folderType:  undefined,
  default:     undefined,
  description: undefined,
  sequence:    undefined,

  outgoingFolderTransitionRules: [],
  campaigns:                     [],
  campaignsCount:                { company: 0, linked: 0 },
  applicationsCount:             [],
};

export default class FolderRecord extends Record(struct, 'FolderRecord') {
  isLinkedToAllCampaigns() {
    return this.campaignsCount && (this.campaignsCount.linked === this.campaignsCount.company);
  }

  getTranslationName() {
    return t(`campaigns.folders.${this.name}.title`, { defaultValue: this.title });
  }
}

export const allFolder = new FolderRecord({ id: 'allfolder', name: 'allfolder', title: t('campaigns.folders.all'), folder_type: 'talkpush'  });
